import { useState } from 'react';

export const useDealDetailModal = () => {
  const [isShownDealDetailModal, setIsShownDealDetailModal] = useState<boolean>(false);
  const toggleDealDetailModal = () => setIsShownDealDetailModal(!isShownDealDetailModal);
  return {
    isShownDealDetailModal,
    toggleDealDetailModal,
  };
};
